import { getOrganizationViewUrlPlaceholder } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { NavigationMenuId } from '../enums/navigationMenuId'
import { NavigationMenuItem } from '../types/NavigationMenuItem'

export const navigationMenuExpertConfig: NavigationMenuItem<NavigationMenuId>[] = [
  {
    id: NavigationMenuId.ExpertMyClient,
    iconLeft: 'userRound', // TODO: replace with circle user round
    label: 'navigation.menu.label.my_client',
    to: getOrganizationViewUrlPlaceholder(reactRoute.organization.myClient.getMainRoute()),
  },
  {
    id: NavigationMenuId.ExpertReports,
    iconLeft: 'chartPie',
    label: 'navigation.menu.label.expert_reports',
    subItems: [
      {
        id: NavigationMenuId.ExpertReportsTrialBalance,
        label: 'navigation.menu.label.expert_reports.trial_balance',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.expertTrialBalance.getMainRoute()),
      },
      {
        id: NavigationMenuId.ExpertReportsSuppliersBalance,
        label: 'navigation.menu.label.expert_reports.suppliers_balance',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.suppliersBalance.getMainRoute()),
      },
      {
        id: NavigationMenuId.ExpertReportsCustomersBalance,
        label: 'navigation.menu.label.expert_reports.customers_balance',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.customersBalance.getMainRoute()),
      },
      {
        id: NavigationMenuId.ExpertReportsProfitAndLoss,
        label: 'navigation.menu.label.expert_reports.profit_and_loss',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.expertProfitAndLoss.getMainRoute()),
      },
      {
        id: NavigationMenuId.ExpertReportsBalanceSheet,
        label: 'navigation.menu.label.expert_reports.balance_sheet',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.expertBalanceSheet.getMainRoute()),
      },
      {
        id: NavigationMenuId.ExpertReportsVatDeclarations,
        label: 'navigation.menu.label.expert_reports.vat_declarations',
        to: getOrganizationViewUrlPlaceholder(reactRoute.organization.expertVatDeclarations.getMainRoute()),
      },
    ],
  },
  {
    id: NavigationMenuId.ExpertDocuments,
    iconLeft: 'folder',
    label: 'navigation.menu.label.documents',
    to: getOrganizationViewUrlPlaceholder(reactRoute.organization.documents.getMainRoute()),
  },
  {
    id: NavigationMenuId.ExpertReviewEntries,
    iconLeft: 'sparkle',
    label: 'review_entries.title',
    to: getOrganizationViewUrlPlaceholder(reactRoute.organization.reviewEntries.getMainRoute()),
  },
]
